"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
const styles = ({ palette, spacing, mixins }) => ({
    dialogPaper: {
        width: '75%',
        minWidth: 800,
    },
    panelContainer: {
        paddingLeft: 2,
        paddingRight: 2,
        '&.disable': {
            pointerEvents: 'none',
            opacity: '0.6',
        },
    },
    panel: {
        borderLeft: `3px solid ${mixins.register.fieldBorderColor}`,
        border: `1px solid ${palette.background.elevated}`,
        padding: 24,
        background: palette.background.paper,
        marginLeft: 0,
        '&.inDialog': {
            borderLeft: 'none',
        },
    },
    ellipsePlaceholder: {
        textOverflow: 'ellipse',
    },
    textField: {
        background: 'transparent',
        flex: 1,
        color: palette.text.primary,
        marginTop: 'auto',
        marginBottom: 'auto',
        paddingLeft: 2,
        marginLeft: 5,
        marginRight: 5,
        borderRadius: 4,
        '&.amountField': {
            maxWidth: spacing(11),
        },
        '&.flex2': {
            flex: 2,
        },
        '&.flex3': {
            flex: 3,
        },
        '& input': {
            paddingLeft: 0,
        },
        '&:focus-within': {
            border: `solid 1px ${mixins.register.fieldBorderColor}`,
            background: palette.background.paper,
            '&:hover': {
                background: palette.background.paper,
            },
        },
        '&:hover': {
            background: mixins.register.fieldHoverColor,
        },
    },
    inputStyle: {
        width: '100%',
        '& input': {
            fontSize: mixins.register.fontSize.default,
            lineHeight: mixins.register.fontSize.default,
            paddingBottom: '4px',
        },
    },
    splitsContainer: {
        width: '100%',
        border: `1px solid ${palette.background.elevated}`,
        borderRadius: 4,
        marginLeft: 0,
        marginRight: 0,
        background: palette.background.paper,
        '&.sidebyside': {
            marginBottom: 24,
            float: 'right',
            display: 'inline-block',
        },
    },
    bankPayeeLink: {
        display: 'inline',
    },
    bankInfoText: {
        fontSize: 12,
        color: palette.text.tertiary,
    },
    bankInfoContainer: {
        padding: 10,
    },
    statementName: {
        color: palette.primary.main,
    },
    rightCol: {
        width: '60%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
    },
    splitsOnly: {
        width: 'inherit',
    },
    splitsDetailsParent: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
    },
    webFirstDetails: {
        width: '40%',
    },
    detailsContainer: {
        width: '40%',
        marginLeft: 0,
        marginRight: 0,
        background: palette.background.paper,
    },
    link: {
        marginLeft: 5,
        verticalAlign: 'inherit',
        cursor: 'pointer',
        color: palette.link.main,
        '&:active': {
            background: palette.background.elevated,
        },
        '&:hover': {
            fontWeight: 'bold',
        },
        width: 'auto',
        textAlign: 'left',
        justifyContent: 'left',
    },
    splitField: {
        display: 'flex',
        flex: 1,
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingLeft: 7,
        paddingRight: 0,
        background: palette.background.paper,
        '&.flex2': {
            flex: 2,
        },
        '&.flex3': {
            flex: 3,
        },
        '&.pointer': {
            cursor: 'pointer',
        },
    },
    splitTitleIcon: {
        flex: '0',
        color: palette.text.secondary,
        margin: 'auto',
        backgroundColor: 'transparent',
    },
    splitTitle: {
        fontSize: mixins.register.fontSize.large,
    },
    switch: {
        marginLeft: 10,
    },
    rowIcons: {
        width: '72px',
        color: palette.text.tertiary,
        background: 'none',
        marginTop: 'auto',
        marginBottom: 'auto',
    },
    pointer: {
        cursor: 'pointer',
    },
    listRow: {
        display: 'flex',
        alignItems: 'stretch',
        background: mixins.register.splitsBackground,
        padding: '5px 10px',
        minHeight: mixins.register.splitRowHeight,
    },
    addIconButton: {
        color: palette.secondary.main,
    },
    headerRow: {
        display: 'flex',
        alignItems: 'stretch',
        backgroundColor: palette.background.paper,
        padding: '6px 0px 6px 5px',
    },
    detailsRow: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        float: 'right',
    },
    footerRow: {
        display: 'flex',
        alignItems: 'stretch',
        marginBottom: '7px',
        background: palette.background.paper,
        marginTop: 6,
    },
    buttons: {},
    buttonHolder: {
        display: 'flex',
        justifyContent: 'flex-end',
        width: '100%',
        borderTop: `solid 1px ${mixins.register.headerBorder}`,
    },
    deleteButton: {
        color: palette.text.warning,
    },
    buttonsLeft: {
        width: 'fit-content',
        textAlign: 'left',
        borderRight: `1px solid ${palette.background.elevated}`,
        borderLeft: `1px solid ${palette.background.elevated}`,
        marginTop: '10px',
        paddingRight: 10,
        background: palette.background.paper,
    },
    buttonsRight: {
        textAlign: 'right',
        marginTop: '10px',
        marginLeft: 10,
        background: palette.background.paper,
    },
    transactionTotalLabel: {
        fontSize: '14px',
        borderBottom: 'solid',
        borderBottomColor: palette.border.dark,
        borderBottomWidth: 2,
        paddingTop: 12,
    },
    transactionTotal: {
        fontSize: '14px',
        fontWeight: 500,
        borderBottom: 'solid',
        borderBottomColor: palette.border.dark,
        borderBottomWidth: 2,
        paddingTop: 12,
    },
    switchFill: {
        width: 57,
    },
});
exports.styles = styles;
